const { isEmpty } = require('lodash');

module.exports = {
  fields: () => ({
    name: {
      label: 'グループ名',
      type: 'string',
      validations: {
        required: (v) => !isEmpty(v),
      },
    },
  }),
};